import { render, staticRenderFns } from "./GuestComponent.vue?vue&type=template&id=49a2e07c"
import script from "./GuestComponent.vue?vue&type=script&lang=js"
export * from "./GuestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports